import ptBr from "./ptBr";
import es from "./es";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { ptBr, es };
